// Klikbare kassier-knop rechtsboven met dropdown-menu (foto 1_menu_kassier.png)
// Gebruik: <KassierMenu onAfmelden={bestaandeLogoutFunctie} />
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../api";

export default function KassierMenu({ onAfmelden }) {
  const [open, setOpen] = useState(false);
  const [me, setMe] = useState(null);
  const ref = useRef(null);
  const nav = useNavigate();

  useEffect(() => {
    api.get("/me").then((r) => setMe(r.data)).catch(() => {});
  }, []);

  useEffect(() => {
    const klik = (e) => ref.current && !ref.current.contains(e.target) && setOpen(false);
    const esc = (e) => e.key === "Escape" && setOpen(false);
    document.addEventListener("mousedown", klik);
    document.addEventListener("keydown", esc);
    return () => {
      document.removeEventListener("mousedown", klik);
      document.removeEventListener("keydown", esc);
    };
  }, []);

  const ga = (pad) => {
    setOpen(false);
    nav(pad);
  };
  const naam = me?.naam || "Kassier";
  const isAdmin = me?.rol === "admin";

  const Item = ({ icoon, bg, titel, sub, onClick, rood }) => (
    <button onClick={onClick}
      className={`w-full flex items-center gap-3 p-3 rounded-xl text-left hover:bg-slate-100 ${rood ? "text-red-600" : "text-slate-800"}`}>
      <span className={`w-9 h-9 rounded-lg flex items-center justify-center text-lg ${bg}`}>{icoon}</span>
      <span>
        <span className="block text-sm font-semibold">{titel}</span>
        {sub && <span className="block text-xs text-slate-500">{sub}</span>}
      </span>
    </button>
  );

  return (
    <div className="relative" ref={ref}>
      <button onClick={() => setOpen((o) => !o)} data-testid="kassier-menu-knop"
        className={`flex items-center gap-2 rounded-full pl-1.5 pr-3 py-1.5 border-2 transition
          ${open ? "border-blue-600 bg-blue-50" : "border-transparent bg-slate-100 hover:border-blue-300"}`}>
        <span className="w-8 h-8 rounded-full bg-blue-600 text-white font-bold flex items-center justify-center">
          {naam.charAt(0).toUpperCase()}
        </span>
        <span className="text-left leading-tight">
          <span className="block text-sm font-semibold text-slate-800">{naam}</span>
          <span className="block text-xs text-slate-500">{isAdmin ? "Beheerder" : "Clerk"}</span>
        </span>
        <span className={`text-blue-600 text-xs ml-1 transition ${open ? "rotate-180" : ""}`}>▼</span>
      </button>

      {open && (
        <>
          <div className="fixed inset-0 top-[72px] bg-slate-900/20 z-40" onClick={() => setOpen(false)} />
          <div className="absolute right-0 mt-2 w-72 bg-white rounded-2xl shadow-2xl p-2 z-50">
            <div className="px-3 pt-2 pb-2">
              <div className="font-bold text-slate-800">{naam}</div>
              {me?.vestiging && <div className="text-xs text-slate-500">Vestiging: {me.vestiging.naam}</div>}
            </div>
            <div className="h-px bg-slate-200 my-1" />
            <Item icoon="🧾" bg="bg-slate-100" titel="Kassa" sub="Terug naar verkoopscherm" onClick={() => ga("/kassa")} />
            <Item icoon="📒" bg="bg-blue-100" titel="Digitale dagontvangsten" sub="Z-tickets · PDF-archief" onClick={() => ga("/dagontvangsten")} />
            <Item icoon="📦" bg="bg-green-100" titel="Bestellingen" sub="Barcodes scannen → mail" onClick={() => ga("/bestellingen")} />
            {isAdmin && <Item icoon="⚙" bg="bg-amber-100" titel="Beheer" sub="Dagboek · Z-tickets · PDF-archief · Centralisatie" onClick={() => ga("/beheer/dagboek")} />}
            <div className="h-px bg-slate-200 my-1" />
            <Item icoon="⇥" bg="bg-red-100" titel="Afmelden" rood onClick={() => { setOpen(false); onAfmelden?.(); }} />
          </div>
        </>
      )}
    </div>
  );
}
